var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modalDeleteCalendarContainer"},[_c('p',[_vm._v("¿Desea eliminar el periodo y sus programas?")]),_c('div',[_c('button',{on:{"click":_vm.buttonYes}},[_vm._v("Si")]),_c('button',{on:{"click":_vm.buttonNo}},[_vm._v("No")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }